// changed map keys
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter, useLocation } from "react-router-dom";
import "./howitworks.scss";
import { getHowItWorksDetails } from "../account/actions";

// images
import menuBg from "../../assets/images/bg/menu/home.svg";
import FooterBottom from "../../components/footerBottom";

// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import SignupModal from "../../components/signupModal";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import logo from "../../assets/images/logo.png";

import { AiOutlineCheckCircle } from "react-icons/ai";
import { Button } from "react-bootstrap";

const Index = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [keyword, setKeyword] = useState("");

  const cookie = new Cookies();

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  useEffect(() => {
    props.getHowItWorksDetails();
  }, []);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (!cookie.get("user_token")) {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    if (props?.howitworks_cms?.keywords?.length > 0) {
      const dataKeyword = props?.howitworks_cms?.keywords;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.howitworks_cms?.keywords]);

  return (
    <>
      <Helmet>
        <title>How It Works - Clarity Cooperative</title>
        <meta name="description" content={props.howitworks_cms?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={props?.howitworks_cms?.name} />
        <meta property="og:url" content={props?.howitworks_cms?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.howitworks_cms?.excerpt} />
        <meta name="twitter:card" content={props.howitworks_cms?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.howitworks_cms?.url} />
        <meta name="twitter:title" content={props?.howitworks_cms?.name} />
        <meta name="twitter:description" content={props.howitworks_cms?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>

      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
      <div className="howitworks">
        <div className="howitworks_container">
          <div className="title_st">
            <p className="sub_title">{props?.howitworks_cms?.subtitle || ""}</p>
            <h1>{props?.howitworks_cms?.name || ""}</h1>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p className="sub_title">Our 4 Step Application Process:</p>
              <div className="flow_st">
                {props?.howitworks_cms?.body?.map((item) => (
                  <div className="singleinfo" key={item?.key}>
                    <div className="number">{item?.key}</div>
                    <div>
                      <h5>{item?.title}</h5>
                      <p>{item?.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <p className="sub_title mt-sm-40">Our 4 Step Application Process:</p>
              <div className="checklist_st">
                <div className="triangle_icon"></div>
                {props?.howitworks_cms?.body?.map((item) => (
                  <div className="singleinfo" key={item?.key}>
                    <div className="icon">
                      <AiOutlineCheckCircle color="#7FD7F2" size={40} />
                    </div>
                    <div>
                      <h5>{item?.title}</h5>
                      <p>{item?.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <Link to={props?.howitworks_cms?.button_link || ""}>
              <Button>
                {props?.howitworks_cms?.button_title || ""}
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <FooterBottom />
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
    </>
  );
};

const mapStateToProps = (state) => ({
  howitworks_cms: state.my_account.howitworks_cms,
});
export default connect(mapStateToProps, {
  getHowItWorksDetails,
})(withRouter(Index));
